<div class="dialog-container" mat-dialog-content>
    <h4 class="condensed dialog-title">Welk project wilt u volgen?</h4>
    <div class="dialog-content mt-3">
        @if (!customerProjects?.length) {
            <div class="pb-4">
                <i>Je volgt al onze projecten al</i>
            </div>
        }
        <mat-radio-group class="mb-3" [(ngModel)]="customerProject">
            @for (project of customerProjects; track project) {
                <div class="my-1 w-100">
                    <mat-radio-button [value]="project">
                        {{ project.name }}<br />
                        <small>{{ project.customer_name }}</small>
                    </mat-radio-button>
                </div>
            }
        </mat-radio-group>
        <button (click)="dialogRef.close()" mat-stroked-button color="primary">Annuleren</button>
        <button
            class="float-right"
            [disabled]="!customerProject"
            (click)="addCustomerProject()"
            mat-raised-button
            color="primary">
            Toevoegen
        </button>
    </div>
</div>
